import { makeStyles } from '@material-ui/core/styles';

export default makeStyles(theme => ({
    action: {
        alignSelf: 'center',
    },
    avatar: {
        borderRadius: 60,
        width: 70,
    },
    avatarWrapper: {
        height: 65,
        width: 65,
    },
    button: {
        '&:hover': {
            backgroundColor: theme.palette.secondary.main,
            color: theme.palette.common.white,
        },
        backgroundColor: theme.palette.secondary.main,
        color: theme.palette.common.white,
    },
    card: {
        // maxWidth: 345,

        margin: '0 auto',
    },
    expand: {
        marginLeft: 'auto',
        transform: 'rotate(0deg)',
        transition: theme.transitions.create('transform', {
            duration: theme.transitions.duration.shortest,
        }),
    },
    expandOpen: {
        transform: 'rotate(180deg)',
    },
    media: {
        borderRadius: '50%',
        height: 0,
        paddingTop: '56.25%', // 16:9
        width: '250',
    },
    nameField: {
        '& .Mui-disabled': {
            color: theme.palette.common.white,
        },
        color: theme.palette.common.white,
        marginLeft: theme.spacing(1),
        marginRight: theme.spacing(1),
        padding: '5px',
    },
    profileImage: {
        borderRadius: 100,
        width: 200,
    },
    promptEventImage: {
        width: 200,
    },
    promptProgress: {
        padding: '10 0',
    },
    promptThumbnail: {
        borderRadius: 150,
        overflow: 'hidden',
        width: 160,
    },
    stat: {
        width: '100%',
    },
    statButton: {
        display: 'flex',
        flexDirection: 'column',
    },
}));
